export default __webpack_public_path__ + "static/media/b1.9ad94626.jpg";